const FormFieldRequired = () => <span className="text-primary">*</span>

export { FormFieldRequired }